import { SectionHeader } from '../rows/SectionHeader'
import { MetricRow } from '../rows/MetricRow'
import { AverageCheckRow } from '../rows/AverageCheckRow'
import type { MonthMetrics } from '@/features/history/types'

interface PrivateSessionsSectionProps {
  metrics: MonthMetrics
  weeklyAvg: (v: number) => number
  formatNumber: (v: number) => string
  formatCurrency: (v: number) => string
  hasPrivateSessionsAvgCheckData: boolean
}

export function PrivateSessionsSection({ metrics, weeklyAvg, formatNumber, formatCurrency, hasPrivateSessionsAvgCheckData }: PrivateSessionsSectionProps) {
  const { private_sessions_count: pCount, private_sessions_amount: pAmt, private_sessions_avg_check: pAvg } = metrics
  return (
    <>
      <SectionHeader label="Индивидуальные / Сплит-тренировки" color="pink" />
      <MetricRow
        label="Индивидуальные (кол-во)"
        metric={pCount}
        weeklyPlan={weeklyAvg(pCount.plan)}
        weeklyFact={weeklyAvg(pCount.fact)}
        formatPlan={formatNumber}
        formatFact={formatNumber}
      />
      <MetricRow
        label="Индивидуальные (сумма)"
        metric={pAmt}
        weeklyPlan={weeklyAvg(pAmt.plan)}
        weeklyFact={weeklyAvg(pAmt.fact)}
        formatPlan={formatCurrency}
        formatFact={formatCurrency}
      />
      {hasPrivateSessionsAvgCheckData && <AverageCheckRow label="Средний чек" metric={pAvg} formatValue={formatCurrency} />}
    </>
  )
}
